import { Model, TModelConstructorType } from '../Model';

export function createInstance<T extends Model, D extends TModelConstructorType<T>>(
  ModelClass: new () => T,
  data?: Partial<D>,
): T {
  const instance = new ModelClass();
  return typeof data !== 'undefined'
    ? instance.$update(data)
    : instance;
}
